/** React Router v7 behaviours, opted in now so the upgrade is a no-op. Used by the app and test routers. */
export const ROUTER_FUTURE = {
  v7_relativeSplatPath: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_partialHydration: true,
  v7_skipActionErrorRevalidation: true,
} as const;

/** `RouterProvider` / `MemoryRouter` prop counterpart. */
export const ROUTER_PROVIDER_FUTURE = { v7_startTransition: true } as const;
